/* src/app/private/components/application/bulk-delete-application/bulk-delete-application.component.scss */
/*# sourceMappingURL=bulk-delete-application.component.css.map */
